import React from "react";
import PropTypes from "prop-types";
import {Col, FormGroup} from "reactstrap";
import DefaultTimePicker from "react-time-picker";
import AsteriskIcon from "../../asteriskIcon";
import HelpIcon from "../../HelpIcon/HelpIcon";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";

const TimeCreator = (props) => {
  const {
    label,
    value,
    onChange = () => {},
    large = false,
    colSize = "6",
    isRequired = false,
    help_text,
    ...rest
  } = props;

  const handleChange = (time) => {
    onChange({
      target: {
        value: time,
        ...rest,
      },
    });
  };

  return (
    <Col md={large ? "12" : colSize}>
      <FormGroup>
        <div className="d-flex">
          {label && (
            <label className="form-control-label" htmlFor="input-name">
              {label}
            </label>
          )}
          {isRequired && <AsteriskIcon />}
          {help_text && (
            <span style={{padding: "0px 5px"}}>
              <HelpIcon text={help_text} target={label} place="right" />
            </span>
          )}
        </div>
        <DefaultTimePicker
          value={value}
          onChange={handleChange}
          format={"H:m"}
          maxDetail={"minute"}
          hourPlaceholder={"hh"}
          minutePlaceholder={"mm"}
          secondPlaceholder={"ss"}
          {...rest}
        />
      </FormGroup>
    </Col>
  );
};

TimeCreator.propTypes = {
  /** Label for form field */
  label: PropTypes.string,
  /** value of time in H:m format */
  value: PropTypes.string.isRequired,
  /** Callback function which will be executed on change of time */
  onChange: PropTypes.func,
  /** If this prop is set to true then this component will take 100% width of parent component */
  large: PropTypes.bool,
  /** This prop will be passed as colSize to reactstrap Col component */
  colSize: PropTypes.string,
  /** This prop determines wether form field is required */
  isRequired: PropTypes.bool,
  /** If value is passed for this prop this will be shown as tooltip when hovered on help icon */
  help_text: PropTypes.string,
};

export default TimeCreator;
